import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance16dzvgcii8pc4 as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.y63_1 = call;
        this.z63_1 = responseData.i5p_1;
        this.a64_1 = responseData.d5p_1;
        this.b64_1 = responseData.g5p_1;
        this.c64_1 = responseData.e5p_1;
        this.d64_1 = responseData.j5p_1;
        var tmp = this;
        var tmp_0 = responseData.h5p_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.e64_1 = tmp0_elvis_lhs == null ? Companion_getInstance().z4o_1 : tmp0_elvis_lhs;
        this.f64_1 = responseData.f5p_1;
      }
      o5o() {
        return this.y63_1;
      }
      gw() {
        return this.z63_1;
      }
      x5o() {
        return this.a64_1;
      }
      y5o() {
        return this.b64_1;
      }
      z5o() {
        return this.c64_1;
      }
      a5p() {
        return this.d64_1;
      }
      w5o() {
        return this.e64_1;
      }
      b56() {
        return this.f64_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
